const wowApp = require('angular').module('wowApp.common');

wowApp.service('ProductGroupService', ['Restangular', '$q', 'FiltersService', 'SearchService', 'DecorateAdditionalDetails', '$log', '$state', '$window', '$timeout', require('./productgroup-service')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/productgroup/index.js
 **/